import React from "react";
import simpleParallax from "simple-parallax-js";
import TweenOne from "rc-tween-one";
import { Parallax } from "rc-scroll-anim";

import { AppBar } from "../components/AppBar";

const HomePage = () => {
  React.useEffect(() => {
    var images = document.getElementsByClassName("parallaxImg");
    new simpleParallax(images);
  }, []);

  return (
    <div>
      <Landing />

      <AppBar />

      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />

      <Footer />
    </div>
  );
};

const Landing = () => {
  return (
    <div className="landing-wrapper">
      <TweenOne
        animation={{ scale: 1.2, opacity: 0, type: "from", duration: 2000 }}
      >
        <div className="landing-image" />
      </TweenOne>

      {/*<div className="landing-text-panel">
        <TweenOne
          className="landing-title"
          animation={{ y: 300, opacity: 0, type: "from", duration: 2000 }}
        >
          YOYO food ~
        </TweenOne>

        <TweenOne
          className="landing-subtitle"
          animation={{
            y: 300,
            opacity: 0,
            type: "from",
            duration: 2000,
            delay: 1000
          }}
        >
          The Fast Way Use Animation In React
        </TweenOne>
        </div>*/}
    </div>
  );
};

const Section1 = () => {
  return (
    <img
      className="parallaxImg"
      src={require("../assets/banner2.png")}
      alt="0"
    />
  );
};

const Section2 = () => {
  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center">
        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating1.png")} alt="0" width="200" />
        </Parallax>

        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating2.png")} alt="0" width="200" />
        </Parallax>

        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            delay: 2000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating3.png")} alt="0" width="200" />
        </Parallax>
      </div>

      <div className="row">
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
          <div style={{ writingMode: "vertical-rl" }}>
            <p>
              我們堅信著&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;取於自然&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;回歸天然
            </p>
            <p>這樣的信念&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;並且</p>
            <p>一步一腳印努力踏實的走著</p>
            <p>期待著透過我們小小的力量</p>
            <p>
              能夠讓土地復甦&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人類與自然回歸平衡
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
          <img
            className="parallaxImg"
            src={require("../assets/img1.png")}
            alt="0"
          />
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating4.png")} alt="0" width="200" />
        </Parallax>

        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating5.png")} alt="0" width="200" />
        </Parallax>

        <Parallax
          animation={{
            y: 0,
            duration: 5000,
            delay: 2000,
            repeatDelay: 2000,
            ease: "easeOutBack",
            zIndex: 2
          }}
          style={{ transform: "translateY(300px)" }}
        >
          <img src={require("../assets/floating6.png")} alt="0" width="200" />
        </Parallax>
      </div>

      <div className="row" style={{ paddingBottom: 100 }}>
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
          <img
            className="parallaxImg"
            src={require("../assets/img2.png")}
            alt="0"
          />
        </div>
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
          <div>
            <p>人類對自然的破壞&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;等同於慢性自殺</p>
            <p>覺醒永遠不嫌晚</p>
            <p>
              善待我們腳下這片土地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;讓天地萬物共存
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Section3 = () => {
  return (
    <div className="d-flex">
      <div className="flex-fill">
        <img
          className="parallaxImg"
          src={require("../assets/img3.png")}
          alt="0"
        />
      </div>

      <div className="flex-fill">
        <img
          className="parallaxImg"
          src={require("../assets/img4.png")}
          alt="0"
        />
      </div>
    </div>
  );
};

const ProductCard = props => {
  return (
    <div className="col-12 col-md-4 d-flex flex-column align-items-center">
      <div className="shadow" style={{ marginTop: 20, marginBottom: 50 }}>
        <img src={props.img} alt="0" />
        <div
          className="d-flex justify-content-end font-weight-bold"
          style={{ marginTop: 50, marginBottom: 30, marginRight: 30 }}
        >
          {props.name}
        </div>
      </div>
    </div>
  );
};

const Section4 = () => {
  return (
    <div className="container">
      <div
        className="row justify-content-center align-items-center"
        style={{ marginTop: 100, marginBottom: 20 }}
      >
        <img src={require("../assets/logo2.png")} alt="0" />

        <img src={require("../assets/logo4.png")} alt="0" className="ml-3" />

        <div className="ml-5">
          <div>透過我們的專業採購及服務，提供商家物美價廉、</div>
          <div>精緻實用的多種生活百貨選擇</div>
        </div>
      </div>

      <div className="row">
        <ProductCard
          img={require("../assets/product1.png")}
          name="植物萃系列"
        />

        <ProductCard
          img={require("../assets/product2.png")}
          name="植物美學系列"
        />

        <ProductCard
          img={require("../assets/product3.png")}
          name="百草植萃堂系列"
        />
      </div>
    </div>
  );
};

const Section5 = () => {
  return (
    <img
      className="parallaxImg"
      src={require("../assets/banner3.png")}
      alt="0"
    />
  );
};

const Section6 = () => {
  return (
    <div
      className="w-100 d-flex justify-content-center align-items-end"
      style={{ marginTop: 100, marginBottom: 100 }}
    >
      <img src={require("../assets/logo3.png")} alt="0" />

      <div className="ml-5">
        <div>
          <span>
            <i className="fa fa-map-marker mr-2" />
            台中市太平區宜欣二路143號
          </span>
          <span style={{ marginLeft: 95 }}>統一編號：53355992</span>
        </div>
        <div>
          <span>
            <i className="fa fa-clock-o mr-2" />
            08：30 - 17：30
          </span>
          <span>
            <i className="fa fa-phone mr-2 ml-4" />
            04 - 23959500
          </span>
          <span>
            <i className="fa fa-fax mr-2 ml-4" />
            04 - 23950033
          </span>
          <span>
            <i className="fa fa-envelope-o mr-2 ml-4" />
            service@tosunny.com.tw
          </span>
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  return (
    <div
      className="w-100 d-flex justify-content-center align-items-center"
      style={{ height: "90px", backgroundColor: "#6ea62b" }}
    >
      <div className="text-white">
        Copyright © TOSUNNY, Inc. All Rights Reserved.
      </div>
    </div>
  );
};

export { HomePage };
